export enum CourseCreateStepEnum {
  ABOUT = 'about',
  MODULES = 'modules',
  CONTENT = 'content',
  SUMMARY = 'summary',
}
